'use client';

import React, {
  useEffect,
  useState,
  FC,
  useRef
} from 'react';
import classNames from 'classnames';
import Card, {
  CardHeader, 
  CardHeaderChild, 
  CardTitle, 
  CardBody,
  CardFooter
} from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import RoomEntry from './RoomEntry';

import { TRoom } from '@/types/room.type';
import { getRooms, getRoomsWebsocketURL } from '@/actions';

interface IChatListProps {
  selectedRoom?: string;
}

const ChatList: FC<IChatListProps> = (prop) => {
  const {
    selectedRoom
  } = prop;

  const classes = classNames(
    'fixed bottom-0 top-0',
    'md:w-[25rem] max-md:-left-[25rem]',
    'p-[0.5rem]'
  )

  const [rooms, setRooms] = useState<TRoom[]>([]);
  
  const wsRef = useRef<WebSocket | null>(null);
  const socketInitiated = useRef<boolean>(false);
  const reconnectAttempts = useRef<number>(0);
  const maxReconnectAttempts = 5;

  useEffect(() => {
    console.log("fetching rooms");
    const fetchChats = async () => {
      const rooms = await getRooms();
      console.log("rooms", rooms);
      setRooms(rooms);
    }
    
    fetchChats();
  }, []);

  useEffect(() => {
    const connectWebSocket = async () => {
      if (socketInitiated.current) {
        return;
      }

      socketInitiated.current = true;

      const url = await getRoomsWebsocketURL();
      const webSocket = new WebSocket(url);

      webSocket.onopen = () => {
        console.log("WebSocket connection opened");
        reconnectAttempts.current = 0;
      }

      webSocket.onmessage = (event) => {
        const room = JSON.parse(event.data);
        console.log("previous rooms", rooms)
        console.log("WebSocket message received:", room);
        setRooms((prevRooms) => [...prevRooms, room])
      }

      webSocket.onclose = (event) => {
        console.log("WebSocket connection closed", event.code, event.reason);
        if (!event.wasClean) {
          socketInitiated.current = false;
          handleReconnect();
        }
      }

      webSocket.onerror = (error) => {
        console.error("WebSocket error:", error);
      }

      wsRef.current = webSocket;
    }

    const handleReconnect = () => {
      if (reconnectAttempts.current < maxReconnectAttempts) {
        const timeout = Math.min(1000 * 2 ** reconnectAttempts.current, 30000);
        setTimeout(() => {
          reconnectAttempts.current += 1;
          connectWebSocket();
        }, timeout);
      } else {
        console.error("Max reconnect attempts reached");
      }
    }

    if (!wsRef.current || wsRef.current.readyState === WebSocket.CLOSED) {
      connectWebSocket();
    }

    return () => {
      if (wsRef.current) {
        console.log("Closing WebSocket connection");
        wsRef.current.close();
      }
    }
  }, [])

  const renderRoomEntries = () => {
    if (!rooms.length) {
      return <div>Empty</div>
    }
    return rooms.map((room, i) => {
      let lastMessageType = '';
      let lastMessageContent: { text?: string } = {};

      if (room.last_message && room.last_message.length > 0) {
        const typeObj = room.last_message.find((msg: { Key: string }) => msg.Key === 'type');
        const contentObj = room.last_message.find((msg: { Key: string }) => msg.Key === 'content');
  
        console.log("typeObj", typeObj);
        console.log("contentObj", contentObj);
        if (typeObj) {
          lastMessageType = typeObj.Value;
        }
        if (contentObj) {
          lastMessageContent = JSON.parse(contentObj.Value);
        }
      }

      let lastMessage = '';
      console.log("lastMessageType", lastMessageType);
      switch (lastMessageType) {
        case 'text':
          lastMessage = lastMessageContent['text'] || "";
          break;
        case 'image':
          lastMessage = 'message with image';
          break;
        case 'media':
          lastMessage = 'message with media';
          break;
        default:
          lastMessage = 'Message';
      }

      return (
        <RoomEntry 
          key={i}
          roomId={room.id}
          name={room.name}
          avatarUrl={room.avatar_url}
          selected={selectedRoom === room.id}
          lastMessage={lastMessage}
        />
      )
    });
  }

  return (
    <div
      className={classes}
    >
      <Card className='h-full'>
        <CardHeader>
          <CardHeaderChild>
            <CardTitle>Chats</CardTitle>
          </CardHeaderChild>
          <CardHeaderChild>
            <Button icon='HeroPencilSquare' variant='solid' className='w-10 h-10 !rounded-full'></Button>
          </CardHeaderChild>
        </CardHeader>
        <CardBody className='overflow-y-auto no-scrollbar !px-2'>
          { renderRoomEntries()}
        </CardBody>
        <CardFooter>
          <div>...</div>
        </CardFooter>
      </Card>
    </div>
  )
}

export default ChatList;